import { STORE_LOCATIONS_SECTION_ID } from "@/config/sellerProfile/storeLocationsCompleteness";

export const STORE_LOCATIONS_SECTIONS = [
    {
        id: STORE_LOCATIONS_SECTION_ID,
        titleKey: "pages.sellerProfile.storeLocations.sections.pickupPoints.title",
        hintKey: "pages.sellerProfile.storeLocations.sections.pickupPoints.hint",
        countsTowardCompleteness: true,
    },
];
